import { useQuery } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import type { EstimateDetail } from "@/interfaces/estimate-detail";
import type { File } from "@/interfaces/estimation.interface";
import { ESTIMATE_KEYS } from "./queryKeys";

export interface GetEstimateDetailData {
  estimationDetail: EstimateDetail[];
  exportedToXactimate: boolean;
  files: File[];
  organizationId?: string;
}

export function useGetEstimateDetailQuery(estimateId: string | undefined) {
  return useQuery({
    queryKey: ESTIMATE_KEYS.detail(estimateId ?? ""),
    queryFn: async () => {
      if (!estimateId) {
        throw new Error("estimateId is required");
      }

      const { data, success, exportedToXactimate, files, organizationId } = await estimateProvider.getEstimateDetail(estimateId);

      if (!success) {
        throw new Error("Failed to fetch estimation detail");
      }

      return {
        estimationDetail: data ?? [],
        exportedToXactimate,
        files: files ?? [],
        organizationId,
      };
    },
    enabled: !!estimateId,
  });
}
